import React from "react";
import { ReactNode } from "react";
import ObservableState from "../utils/ObservableState";
import * as ui from "../native";
import ObservableComponent from "./ObservableComponent";
import BaseUIProps, { copyBaseUIProps } from "../native/ui/BaseUIProps";
import TextView from "./TextView";
import Checkbox from "./Checkbox";

type _TitleWithCheckboxOnChanged = (value: boolean) => void;

export interface TitleWithCheckboxProps extends BaseUIProps {
  key?: string;
  value?: boolean;
  activeColor?: ui.Color;
  title: string;
  disable?: boolean;
  onChanged?: _TitleWithCheckboxOnChanged;
}

class _TitleWithCheckboxState extends ObservableComponent<TitleWithCheckboxProps> {
  static defaultProps = {
    value: false,
    activeColor: null,
    title: "",
    disable: false,
    onChanged: null,
  };
  public constructor(props: TitleWithCheckboxProps) {
    super(props);

    this.initState();
  }
  public get value(): boolean {
    return this.props.value;
  }
  public get activeColor(): ui.Color {
    return this.props.activeColor;
  }
  public get title(): string {
    return this.props.title;
  }
  public get disable(): boolean {
    return this.props.disable;
  }
  public initState() {
    super.initState();

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {
    this.on(["activeColor", "disable", "title", "value"], this.rebuild);
  }
  public componentDidUpdate(prevProps: TitleWithCheckboxProps): void {
    super.componentDidUpdate(prevProps);

    if (prevProps.value !== this.props.value) {
      this.fire("value", this);
    }

    if (prevProps.activeColor !== this.props.activeColor) {
      this.fire("activeColor", this);
    }

    if (prevProps.title !== this.props.title) {
      this.fire("title", this);
    }

    if (prevProps.disable !== this.props.disable) {
      this.fire("disable", this);
    }
  }
  public render(): ReactNode {
    return ui.Row({
      mainAxisAlignment: ui.MainAxisAlignment.spaceBetween,
      children: [
        TextView({
          data: this.title,
          style: new ui.TextStyle({ color: new ui.Color(0xff3c3e49) }),
          className: "xe5f vc",
          key: "0",
        }),
        Checkbox({
          value: this.value,
          disable: this.disable,
          activeColor: this.activeColor,
          onChanged: (val) => {
            this.onChangedLeftCheckBoxHandler(val);
          },
          className: "vc",
          key: "1",
        }),
      ],
      onTap: (e) => {
        e.stopPropagation();

        this.onTap();
      },
      className: ui.join(this.props.className, "TitleWithCheckbox x75 hc vc h"),
      ...copyBaseUIProps(this.props),
    });
  }
  public onChangedLeftCheckBoxHandler = (val: boolean): void => {
    if (this.onChanged !== null && !this.disable) {
      this.onChanged(val);
    }
  };
  public onTap = (): void => {
    if (this.onChanged !== null && !this.disable) {
      this.onChanged(!this.value);
    }
  };
  public get onChanged(): _TitleWithCheckboxOnChanged {
    return this.props.onChanged;
  }
}
export default function TitleWithCheckbox(props: TitleWithCheckboxProps) {
  return React.createElement(_TitleWithCheckboxState, {
    ..._TitleWithCheckboxState.defaultProps,
    ...props,
  });
}
